import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fileUrl = (u) => (!u ? "" : u.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);

const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("zylo_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401 && localStorage.getItem("zylo_token")) {
      localStorage.removeItem("zylo_token");
      const p = window.location.pathname;
      const onStorefront = p.startsWith("/site/") || p.startsWith("/preview") || p === "/";
      if (!p.startsWith("/login") && !onStorefront) window.location.href = "/login";
    }
    return Promise.reject(e);
  }
);

export default api;

export const fmtINR = (n) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n || 0);

export const fmtDate = (d) => {
  if (!d) return "—";
  return new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
};

export const fmtDateTime = (d) => {
  if (!d) return "—";
  return new Date(d).toLocaleString("en-IN", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });
};

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
};
